var React = require('react');

function EmailStrikethrough (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10.586 0L12 1.413L11.999 1.414L11.996 1.41L1.40949 11.9965L0 10.587L1.58685 9H1V4.926L4.38952 6.19707L5.55453 5.03195L1 3.324V2H8.58619L10.586 0Z","fill":"#929088","key":0}),React.createElement("path",{"d":"M1.412 11.999L1.413 12L1.414 11.999H1.412Z","fill":"#929088","key":1}),React.createElement("path",{"d":"M7.2326 9H11V5.23211L7.2326 9Z","fill":"#929088","key":2})]);
}

EmailStrikethrough.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = EmailStrikethrough;

EmailStrikethrough.default = EmailStrikethrough;
